export default __webpack_public_path__ + "static/media/basic-pin-small-15.96c7fac3.png";